import Vue from 'vue';
import Router from 'vue-router';
import { TokenService } from '../services/storage.service';
/*import { UserService } from '../services/user.service';*/
import store from "../store";

import Home from './../views/Home.vue';
import Login from './../views/Login.vue';
import Register from './../views/Register.vue';
import ProductList from './../views/ProductList.vue';
import TyreType from './../views/TyreType.vue';
import Brand from './../views/Brand.vue';
import Model from './../views/Model.vue';
/*import ProductDetails from './../views/ProductDetails.vue';*/
import ProductDetailsNew from './../views/ProductDetailsNew.vue';
import NotFound from './../views/NotFound.vue';
import ThankYou from './../views/ThankYou.vue';
/*import MemberLogin from './../views/admin/MemberLogin.vue';
import LoginAsCustomer from './../views/admin/LoginAsCustomer.vue';*/
import ResetPasswordLink from './../views/ResetPasswordLink.vue';
import ResetPassword from './../views/ResetPassword.vue';
import UnAuthorized from './../views/UnAuthorized.vue';
/*import EditProfile from './../views/EditProfile.vue';*/
import MyAccount from './../views/MyAccount.vue';
import BecomeAPartner from './../views/BecomeAPartner.vue';
import Cart from './../views/Cart.vue';
import Profile from './../views/Profile.vue';
import Order from './../views/Profile.vue';
import ChangePassword from './../components/ChangePassword';
import CmsPage from './../views/CmsPage.vue';
/*import DetNotFound from './../views/NotFound.vue';*/
import TabAppointments from "../components/TabAppointments";
import TabUserInformation from "../components/TabUserInformation";
import TabOrderSummary from "../components/TabOrderSummary";
import TabOrderConfirm from "../components/TabOrderConfirm";
import TyreSeason from './../views/TyreSeason.vue';
import TyreSize from './../views/TyreSize.vue';
import ProductDetailWithNewBreadcrumb from "../views/ProductDetailWithNewBreadcrumb.vue";
import LandingPage from "../views/LandingPage.vue";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        public: true,  // Allow access to even if not logged in
      }
    }, 
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        public: true,
        onlyWhenLoggedOut: true
      }
    }, 
    {
      path: '/my-account',
      name: 'my-account',
      component: MyAccount,
      meta: {
        public: false
      }
    }, 
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        public: false
      }
    },
    {
      path: '/order/:orderid',
      name: 'order-detail',
      component: Profile,
      meta: {
        public: false
      }
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      component: ChangePassword,
      meta: {
        public: false
      }
    }, 
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        public: true,
        onlyWhenLoggedOut: true
      }
    },
    {
      path: '/products',
      name: 'products',
      component: ProductList,
      meta: {
        public: true,
        // onlyWhenLoggedOut: true
      }
    },
    {
      path: '/campaign/:slug',
      name: 'campaign_en',
      component: LandingPage,
      meta: {
        public: true
      }
    },
    {
      path: '/kampanja/:slug',
      name: 'campaign_fi',
      component: LandingPage,
      meta: {
        public: true
      }
    },
    {
      path: '/tyre/:brand/:productName/:productid',
      name: 'product-details',
      component: ProductDetailsNew,
      meta: {
        public: true,
        // onlyWhenLoggedOut: true
      }
    }, 
    {
      path: '/product-details/:productid',
      name: 'product-details-legacy',
      component: ProductDetailsNew,
      meta: {
        public: true,
        // onlyWhenLoggedOut: true
      }
    },
    {
      path: '/product-details-new/:productid',
      name: 'product-details-new',
      component: ProductDetailsNew,
      meta: {
        public: true,
        // onlyWhenLoggedOut: true
      }
    },
    {
      path: '/tyres/:vehicletype?',
      name: 'product_list_by_vehicle_type',
      component: ProductList,
      meta: {
        public: true
      }
    },
    {
      path: '/renkaat/:vehicletype?',
      name: 'product_list_by_vehicle_type_fi',
      component: ProductList,
      meta: {
        public: true
      }
    },
    {
      path: '/tyres/:vehicle_type/:tyre_season/:tyre_size/:brand/:model/:load_speed_index?/:reinforced?',
      name: 'single_product',
      component: ProductDetailWithNewBreadcrumb,
      meta: {
        public: true
      }
    },
    {
      path: '/renkaat/:vehicle_type/:tyre_season/:tyre_size/:brand/:model/:load_speed_index?/:reinforced?',
      name: 'single_product_fi',
      component: ProductDetailWithNewBreadcrumb,
      meta: {
        public: true
      }
    },
    {
      path: '/thankyou',
      component: ThankYou,
      name: 'thankyou',
      meta: { public: false}
    },
    {
      path: '/order',
      component: Order,
      name: 'order',
      meta: { public: false}
    },
    {
      path: '*',
      name: 'page-not-found',
      component: NotFound,
      meta: {
        public: true
      }
    },
    {
      path: '/access-denied',
      name: 'access-denied',
      component: UnAuthorized,
      meta: {
        public: true
      }
    },
    {
      path: '/become-a-partner',
      name: 'become-a-partner',
      component: BecomeAPartner,
      meta: {
        public: true
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
      children: [
        {
          path: 'dealer-services',
          name:'dealer-services',
          component: TabAppointments
        },
        {
          path: 'confirmation/:orderNumber',
          name:'order-confirm',
          component: TabOrderConfirm
        },
        {
          path:'user-info/:orderNumber?',
          name:'cart-user-info',
          component: TabUserInformation
        },
        {
          path: 'order-summary/:orderNumber',
          name:'order-summary',
          component: TabOrderSummary
        },
        // { 
        //     path: 'payment/failed(.*)',
        //     name: 'status-failed',
        //     // redirect: { name: 'order-summary' },
        //     component: TabOrderSummary
        //   },
        //   { 
        //     path: 'payment/success(.*)',
        //     name: 'status-success',
        //     component: TabOrderSummary
        //   },
        //   { 
        //     path: 'payment/confirm(.*)',
        //     name: 'status-confirm',
        //     component: TabOrderSummary
        //   },
      ],
      meta: {
        public: true
      }
    },
    { 
      path: '/resetpassword',
      component: ResetPasswordLink,
      name: 'reset-password-link',
      meta: { 
        public: true 
      } 
    },
    {
      path: '/password/reset/:token',
      component: ResetPassword,
      name: 'reset-password',
      meta: {
        public: true
      }
    },
    { 
      path: '/tyre-size/:height_width_diameter',
      name: 'search-by-tyresize-height-width-diameter',
      component: TyreSize,
      meta: {
        public: true
      }
    },
    { 
      path: '/brand/:brandname',
      name: 'search-by-brand',
      component: Brand,
      meta: {
        public: true
      }
    },
    { 
      path: '/season/:seasonname',
      name: 'search-by-season',
      component: TyreSeason,
      meta: {
        public: true
      }
    },
    { 
      path: '/brand/:brandname/model/:modelname',
      name: 'search-by-model',
      component: Model,
      meta: {
        public: true
      }
    },
    { 
      path: '/tyre/:tyrecategory',
      name: 'search-by-tyretype',
      component: TyreType,
      meta: {
        public: true
      }
    },
    { 
      path: '/information/:pagepath',
      name: 'cmspage',
      component: CmsPage,
      meta: {
        public: true
      }
    },
    // { 
    //   path: '/cart/user-info',
    //   name: 'cart-user-info',
    //   component: Cart,
    //   meta: {
    //     public: true
    //   }
    // },
    // { 
    //   path: '/cart/dealer-services',
    //   name: 'dealer-services',
    //   component: Cart,
    //   meta: {
    //     public: true
    //   }
    // },
    { 
      path: '/payment/:status?',
      name: 'payment-status',
      component: Cart,
      meta: {
        public: true
      }
    },
    {
      path: '/klarna_payment',
      name: 'klarna-payment-verification',
      component: Cart,
      meta: {
        public: true
      }
    },
    {
      path: '/klarna_payment/:status/:orderNumber',
      name: 'klarna-payment-status',
      component: Cart,
      meta: {
        public: true
      }
    },
    // { 
    //   path: '/cart/confirmation',
    //   name: 'order-confirm',
    //   component: Cart,
    //   meta: {
    //     public: true
    //   }
    // },
    // { 
    //   path: '/cart/order-summary/:orderNumber',
    //   name: 'order-summary',
    //   component: Cart,
    //   meta: {
    //     public: true
    //   }
    // },
    {
      path: 'page-not-found',
      name: 'page-not-found-redirect',
      component: NotFound,
      meta: {
        public: true
      }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)  
  const loggedIn = !!TokenService.getToken();

  //Do not allow user to visit page if page is not public and user is not loggedin
  if (!isPublic && !loggedIn) {
    TokenService.removeToken();

    return next({
      path:'/login',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/');
  }
    
  if (to.name == 'login') {
    let fullPath = from.fullPath;
    if (from.name == 'reset-password' || from.name == 'reset-password-link' || from.name == 'user-activate') {
      fullPath = '/';
    }
    localStorage.setItem('previousUrl', fullPath)
  }
  
  return next();
})

router.afterEach((to) => {
  store.dispatch("HeaderFooterControl/setHeaderControl", to.name)
  store.dispatch("HeaderFooterControl/setFooterControl", to.name)
  store.dispatch("HeaderFooterControl/setCampaignControl", to.name)
})

export default router;


// for dynamic sitemap generate
// function getRoutesList(routes, pre) {
//   return routes.reduce((array, route) => {
//     const path = `${pre}${route.path}`;

//     if (route.path !== '*') {
//       array.push(path);
//     }

//     if (route.children) {
//       array.push(...getRoutesList(route.children, `${path}/`));
//     }

//     return array;
//   }, []);
// }

// console.log(getRoutesList(router.options.routes, 'https://zigamiklic.com'));